<div class="test-link-response">
  <ul>
    <li>
      <b>Status Code</b>: {{data.apitest.statusCode}}
    </li>
    <li class="request-link">
      <b>Requested Link</b>: {{data.apitest.link}}
    </li>
    <li>
      <b>Content Type</b>: {{data.apitest.contentType}}
    </li>
    <li>
      <b>Response Body</b>: {{data.apitest.body}}
    </li>
  </ul>
  <div class="company-settings__buttons" *nzModalFooter>
    <button nz-button nzType="default" (click)="close()">Close</button>
  </div>
</div>